import Web3 from 'web3';
import SamplePacksContract from 'decentralized/contracts/samplePacksContract.js';
import SamplePack from 'repos/SamplePack.js';
import ipfs from 'decentralized/Ipfs.js';
import {bytes32ToIPFSHash, ipfsHashToBytes32} from 'decentralized/ethereumUtils.js';
import {web3} from 'decentralized/web3.js';

const contract = new SamplePacksContract();

/**
 * SamplePacks is responsible with communicating with ethereum & ipfs to
 * fetch sample packs for users
 */
class SamplePacks {
    constructor() {
        if (web3  === undefined) {
            return;
        }
        if (web3.eth.net.isListening()) {
            this.contract = new web3.eth.Contract(contract.abi, contract.contractAddress);
            this.ethAddress = this.contract.options.address;
        }
    }

    updateSamplePack(id, samplePack) {
        return new Promise(async (resolve, reject) => {
            // given the sample pack it first uploads to ipfs
            let hash = await ipfs.addJson(samplePack.getJson());
            const accounts = await web3.eth.getAccounts();
            // then sends the hash to ethereum
            this.contract.methods.updateSamplePackSamples(id, ipfsHashToBytes32(hash))
                .send({
                    from: accounts[0] 
                }, (error, transactionHash) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
        });
    }

    newSamplePack(samplePack) {
        return new Promise(async (resolve, reject) => {
            // given the sample pack it first uploads to ipfs
            let hash = await ipfs.addJson(samplePack.getJson());
            const accounts = await web3.eth.getAccounts();
            // then sends the hash to ethereum
            this.contract.methods.newSamplePack(ipfsHashToBytes32(hash))
                .send({
                    from: accounts[0] 
                }, (error, transactionHash) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
        });
    }

    getAllSamplePacks() {
        return new Promise(async (resolve, reject) => {
            let numberOfSamplePacks = await this.contract.methods.getNumberOfSamplePacks().call();

            let promises = [];
            for (let i=1; i <= numberOfSamplePacks; i++) {
                promises.push(new Promise(async (resolve, reject) => {
                    let hash = await this.contract.methods.getSamplePackIpfsHash(i).call();
                    let json = await ipfs.getJson(bytes32ToIPFSHash(hash));
                    let samplePack = new SamplePack();
                    samplePack.id = i;
                    resolve(samplePack.fromJson(json));
                }));
            }

            let samplePacks = await Promise.all(promises);
            resolve(samplePacks.filter(s => !s.isArchived).reverse());
        });
    }
}

export default SamplePacks;
